import { Weddings } from '@bridebook/models';
import { IPreferenceVenue } from '@bridebook/models/source/models/Weddings/Preferences/venue.types';
import { useQuery } from '@tanstack/react-query';
import { toMillis, useSelector } from '@bridebook/web/lib/utils';
import { getWeddingId } from '../selectors';

const QUERY_CACHE = toMillis(1, 'hour');

const getWeddingVenuePreferences = async (weddingId: string) => {
  const weddingVenuePreferences: IPreferenceVenue = await Weddings._.getById(weddingId)
    .Preferences.getById('venue')
    .get();

  return {
    mustHaves: weddingVenuePreferences?.mustHaves || [],
    styles: weddingVenuePreferences?.styles || [],
    types: weddingVenuePreferences?.types || [],
  };
};

export const useGetWeddingVenuePreferencesQuery = () => {
  const weddingId = useSelector(getWeddingId);

  const { data, isFetched } = useQuery(
    ['weddingVenueMustHaves', weddingId],
    async () => await getWeddingVenuePreferences(weddingId),
    { enabled: !!weddingId, staleTime: QUERY_CACHE, cacheTime: QUERY_CACHE },
  );

  return {
    weddingVenueMustHaves: data?.mustHaves,
    weddingVenueStyles: data?.styles,
    weddingVenueTypes: data?.types,
    isFetched,
  };
};
